import { render, staticRenderFns } from "./miniprogramAgreement.vue?vue&type=template&id=171e0c0f&scoped=true&"
import script from "./miniprogramAgreement.vue?vue&type=script&lang=js&"
export * from "./miniprogramAgreement.vue?vue&type=script&lang=js&"
import style0 from "./miniprogramAgreement.vue?vue&type=style&index=0&id=171e0c0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171e0c0f",
  null
  
)

export default component.exports